import { Keyboard, KeyboardEventName, Platform } from 'react-native';
import { useEffect, useState } from 'react';

const keyboardHideEvent: KeyboardEventName =
  Platform.OS === 'android' ? 'keyboardDidHide' : 'keyboardWillHide';
const keyboardShowEvent: KeyboardEventName =
  Platform.OS === 'android' ? 'keyboardDidShow' : 'keyboardWillShow';

interface Options {
  onHide?: () => void;
  onShow?: () => void;
}

export const useKeyboardVisibility = ({ onShow, onHide }: Options = {}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hideListener = Keyboard.addListener(keyboardHideEvent, () => {
      onHide?.();
      setVisible(false);
    });
    const showListener = Keyboard.addListener(keyboardShowEvent, () => {
      onShow?.();
      setVisible(true);
    });

    return () => {
      hideListener.remove();
      showListener.remove();
    };
  }, [onHide, onShow]);

  return visible;
};
